<template>
<div>
<CDataTable
    :items="Object.values(commissions)"
    :fields="$dataTableFieldsMaker(fields)" hover
>
    <template #limit="{item}">
        <td>
            <span v-if="item.limit && item.limit.length === 0" class="p-1 square alert alert-success">
                {{ $t('commission.without_limit_brif') }}
            </span>
            <span v-else-if="item.limit === null" class="p-1 square alert alert-success">
                {{ $t('commission.without_limit_brif') }}
            </span>
            <span v-else>
                {{ $numberWithCommas(item.limit) }} {{ $t('rial') }}
            </span>
        </td>
    </template>

    <template #actions="{item}">
        <td class="align-middle text-center">
            <CLink class="px-1" @click="deleteModal(item)">
                <FaIcon icon="trash" class="text-danger" />
            </CLink>
        </td>
    </template>
</CDataTable>
<CModal :title="$t('commission.delete')" color="danger" :show.sync="showModal">
    {{ $t('commission.are_you_sure_to_remove', { attribute: deleteItem.display_name }) }}
    <template #footer>
        <CButton @click="showModal = false" color="secondary">
            {{ $t('cancel') }}
        </CButton>
        <CButton @click="deleteCommission" color="danger">
            {{ $t('delete') }}
        </CButton>
    </template>
</CModal>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CCustomInputCheckbox } from '@/components/form'
import CommissionForm from '@/views/commissions/partials/Form'
import { commissionService } from '@/services/api'

export default {
    name: 'SetupCommissionsTable',

    components: {
        CommissionForm,
        CCustomInputCheckbox
    },

    props: {
        submit: {
            default: function () {},
            type: Function
        },
    },

    data() {
        return {
            deleteItem: {},
            showModal: false,
            fields: [
                {
                    key: 'name',
                    label: this.$t('commission.name'),
                    _style: 'width: 15%'
                },
                {
                    key: 'display_name',
                    label: this.$t('commission.display_name'),
                    _style: 'width: 20%',
                },
                {
                    key: 'benefit',
                    label: this.$t('commission._')+'('+this.$t('percent')+')',
                    _style: 'width: 20%',
                },
                {
                    key: 'limit',
                    label: this.$t('commission.limit'),
                    _style: 'width: 30%',
                },
                {
                    key: 'actions',
                    label: this.$t('actions'),
                    _style: 'width: 10%',
                }
            ]
        }
    },

    computed: {
        ...mapGetters('commission', [
            'commissions'
        ]),
    },

    methods: {
        fetchCommission() {
            this.$store.dispatch('commission/fetch', {
                per_page: 100,
            })
        },
        submitForm() {
            this.addToList()
            this.submit()
        },
        deleteModal(promotion) {
            this.deleteItem = promotion
            this.showModal = true
        },
        deleteCommission() {
            this.showModal = false
            commissionService.delete(this.deleteItem.id).then(() => this.fetchCommission())
        },
    }
}
</script>